<template>
  <div class="app-container">
    <el-form ref="form" label-position="left" label-width="120px" size="small" :model="form" :rules="rules">
      <h2>基本信息</h2>
      <el-form-item class="w500" prop="coupon_title" label="优惠券名称">
        <el-input v-model="form.coupon_title" placeholder="最多10个字"></el-input>
      </el-form-item>
      <el-form-item class="w500" prop="coupon_num" label="发放数量">
        <el-input v-model.number="form.coupon_num" placeholder="最多100000张"></el-input>
        <label>修改优惠券总量时只能增加不能减少，请谨慎设置</label>
      </el-form-item>
      <el-form-item prop="can_use_cat_type" label="适用商品">
        <!--  <el-radio-group v-model="form.can_use_cat_type">
                    <div><el-radio label="1">全部商品可用</el-radio></div>
                    <div>  <el-radio label="2">指定分类可用</el-radio></div>
                    <div class="select-class"><i v-if="form.can_use_cat_type==2" class="el-icon-circle-plus" @click="addCanuse">添加分类
                        <span v-for="item in selectClass">{{ item.title }}</span>
                    </i></div>
                    <div><el-radio label="3">指定分类不可用</el-radio></div>
                    <div class="select-class"><i v-if="form.can_use_cat_type==3" class="el-icon-circle-plus" @click="addCanuse">添加分类</i>
                        <span v-for="item in selectClass">{{ item.title }}</span></div>

                </el-radio-group> -->
        <el-radio v-model="form.can_use_cat_type" :label="1">全部商品可用</el-radio><br />
        <el-radio v-model="form.can_use_cat_type" :label="2" @change="classChange">指定分类可用</el-radio><br />
        <div v-if="form.can_use_cat_type == 2" class="select-class">
          <i class="el-icon-circle-plus" @click="addCanuse"
            >添加分类
            <span v-for="item in selectClass">{{ item.title || item.uuid }}</span>
          </i>
        </div>
        <el-radio v-model="form.can_use_cat_type" :label="3" @change="classChange">指定分类不可用</el-radio>
        <div v-if="form.can_use_cat_type == 3" class="select-class">
          <i class="el-icon-circle-plus" @click="addCanuse">添加分类</i>
          <span v-for="item in selectClass">{{ item.title || item.uuid }}</span>
        </div>
      </el-form-item>
      <el-form-item class="w250" prop="use_type" label="使用门槛">
        <el-radio v-model="form.use_type" :label="1">无限制</el-radio>
        <el-form-item prop="use_money" label-width="0" style="width: 100%; white-space: nowrap">
          <el-radio v-model="form.use_type" :label="2">
            订单满
            <el-input v-model="form.use_money" placeholder="必须大于优惠金额" class="w150"></el-input>
            元
          </el-radio>
        </el-form-item>
      </el-form-item>
      <el-form-item class="w500" prop="coupon_money" label="优惠内容">
        满减：减免
        <el-input v-model="form.coupon_money" class="w150"></el-input>
        元
      </el-form-item>
      <el-form-item class="w250" prop="expire_type" label="用券时间">
        <el-radio v-model="form.expire_type" :label="1">
          <el-date-picker
            v-model="times"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :disabled="form.expire_type == 2"
            :picker-options="pickerOptions0"
            @change="changTime"
          >
          </el-date-picker>
        </el-radio>
        <el-radio v-model="form.expire_type" :label="2" class="lh75">
          领券当天起
          <el-input
            v-model="form.expire_day"
            class="w150"
            :disabled="form.expire_type == 1"
            @input="changeVal('expire_day')"
          ></el-input>
          天内可用
        </el-radio>
      </el-form-item>
      <h2>领取和使用规则</h2>
      <el-form-item class="w500" prop="coupon_desc" label="使用说明">
        <el-input
          v-model="form.coupon_desc"
          type="textarea"
          :rows="3"
          placeholder="适用商品+使用门槛+优惠内容组成"
          maxlength="200"
          show-word-limit
        ></el-input>
      </el-form-item>
    </el-form>
    <div class="footer">
      <el-button type="primary" :loading="submitLoading" @click="formSubmit"> 确定 </el-button>
      <el-button @click="backList">取消</el-button>
    </div>
    <!--指定分类可用-->
    <!-- <el-dialog title="分类选择（指定分类可用）" :visible.sync="showUseClassDialog">
            <el-table :data="classList" @selection-change="handleUseClassSelectionChange">
                <el-table-column
                    type="selection"
                    width="55"
                >
                </el-table-column>
                <el-table-column property="id" label="ID"></el-table-column>
                <el-table-column property="name" label="分类"></el-table-column>
            </el-table>
        </el-dialog> -->
    <!--指定分类不可用-->
    <el-dialog title="分类选择 " :visible.sync="showNotUseClassDialog">
      <el-table
        ref="multipleTable"
        :data="classList"
        height="50vh"
        @selection-change="handleNotUseClassSelectionChange"
      >
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column type="index" label="序号"></el-table-column>
        <el-table-column property="title" label="分类"></el-table-column>
      </el-table>
      <div style="text-align: center">
        <el-button @click="subClass">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { couponDetail, getStyle, addCoupon, editCoupon } from "@/api/operation.js";
import { getCate } from "@/api/product.js";
export default {
  data() {
    return {
      times: [],
      selectClass: [],
      pickerOptions0: {
        disabledDate(time) {
          const three = new Date().getTime() + 180 * 24 * 3600 * 1000;
          // return time.getTime() < Date.now() - 8.64e7;
          return time.getTime() < Date.now();
        },
      },
      form: {
        id: null,
        name: "",
        num: "",
        applyGoodsType: 0, // {0: 全部商品， 1：指定分类可用， 2： 指定分类不可用}
        applyClass: [], // 可用的分类
        notApplyClass: [], // 不可用的分类
        useRequire: 0, // {0: 无限制， 1： 订单满xx元}
        orderOutMoney: 10,
        couponMoney: 10, // 优惠内容
        useTimeType: 0, // {0: 指定用券时间， 1： 指定领券后xx天内可用}
        useTimeRange: [],
        useToDay: "",
        desc: "",
        expire_day: "",
        use_money: "",
      },
      submitLoading: false,
      showClassDialog: false,
      classList: [],
      showUseClassDialog: false,
      showNotUseClassDialog: false,
      rules: {
        coupon_title: [
          {
            required: true,
            message: "请输入优惠券名称",
            trigger: "blur",
          },
          {
            max: 10,
            message: "最多10个字",
            trigger: "blur",
          },
        ],
        can_use_cat_type: [
          {
            required: true,
            message: "请选择适用商品",
            trigger: "change",
          },
        ],
        use_type: [
          {
            required: true,
            message: "请选择使用门槛",
            trigger: "change",
          },
        ],
        expire_type: [
          {
            required: true,
            message: "请选择过期类型",
            trigger: "change",
          },
        ],
        coupon_desc: [
          {
            required: true,
            message: "请输入优惠卷描述",
            trigger: "blur",
          },
        ],
        use_money: [
          {
            pattern: /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/,
            message: "请输入正确格式,可保留两位小数",
          },
        ],
        coupon_money: [
          { required: true, message: "请输入", trigger: "blur" },
          {
            pattern: /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/,
            message: "请输入正确格式,可保留两位小数",
          },
        ],
        coupon_num: [
          {
            required: true,
            message: "请输入发放数量",
            trigger: "blur",
          },
          {
            type: "number",
            max: 100000,
            message: "需要输入数字，最多100000张",
            trigger: "blur",
          },
        ],
      },
    };
  },
  async mounted() {
    this.form = this.$route.query;
    if (this.$route.query.coupon_id) {
      await this.getDetail(this.$route.query.coupon_id);
    }
    this.getClassList();
  },
  methods: {
    changeVal(key) {
      this.form[key] = (this.form[key] + "").replace(/[^0-9]/gi, "");
    },
    subClass() {
      this.showNotUseClassDialog = false;
    },
    getClassList() {
      console.log("wwww");
      getCate({ status: 2 }).then((res) => {
        if (res.data instanceof Array) {
          this.classList = res.data;
          this.total = res.total;
          this.selectClass.forEach((it) => {
            if (!it.title) {
              const mi = res.data.find((mm) => {
                return mm.uuid == it.uuid;
              });
              it.title = mi.title;
            }
          });
        }
      });
    },
    changTime(val) {
      if (val) {
        this.form.start_time = val[0];
        this.form.end_time = val[1];
      } else {
        this.form.start_time = "";
        this.form.end_time = "";
      }
    },
    async getDetail(uuid) {
      const res = await couponDetail(uuid);
      if (res) {
        const selectClass = res.can_use_cat_str; // .map(it => {
        //     return { uuid: it }
        // })
        res.can_use_cat_str = res.can_use_cat_str.map((it) => {
          return it.uuid;
        });
        console.log(selectClass);
        this.times = [res.start_time, res.update_time];
        this.selectClass = selectClass;
        this.form = res;
      }

      console.log(res);
    },
    getCouponDetail() {
      // TODO : 获取优惠券详情接口对接
    },
    classChange() {
      this.form.can_use_cat_str = [];
      this.selectClass = [];
    },
    addCanuse() {
      this.showNotUseClassDialog = true;
      this.$nextTick(() => {
        const sc = this.selectClass;
        this.$refs.multipleTable.clearSelection();
        this.classList.forEach((row) => {
          const ind = sc.findIndex((mi) => {
            return mi.uuid == row.uuid;
          });
          if (ind > -1) {
            console.log(ind);
            this.$refs.multipleTable.toggleRowSelection(row, true);
          }
        });
      });
    },
    handleUseClassSelectionChange(val) {
      this.form.applyClass = val;
    },
    handleNotUseClassSelectionChange(val) {
      console.log(val);
      this.form.can_use_cat_str = val.map((it) => {
        return it.uuid;
      });
      this.selectClass = val;
    },

    formSubmit() {
      this.$refs["form"].validate(async (valid) => {
        if (valid) {
          if (this.form.expire_type == 2 && this.form.expire_day == 0) {
            this.$message.warning("领券当天起天数不能为0");
            return;
          }
          // if (this.form.use_type == 2 && this.form.use_money == 0) {
          //     this.$message.warning('使用门槛应为无限制或输入门槛金额')
          //     return
          // }
          this.submitLoading = true;
          const coupon_id = this.form.coupon_id;
          const data = { ...this.form };

          // this.form.can_use_cat_str = val.map(it => {
          //     return it.uuid
          // })
          if (!coupon_id) {
            addCoupon(this.form).then((res) => {
              if (res == true) {
                this.$message.success("成功");
                this.$router.push({
                  path: "/coupon",
                });
              }
            });
          } else {
            editCoupon(this.form, this.form.coupon_id).then((res) => {
              if (res == true) {
                this.$message.success("成功");
                this.$router.push({
                  path: "/coupon",
                });
              }
            });
          }

          this.$notify({ title: "操作成功", type: "success" });
          this.submitLoading = false;
          this.backList();
        }
      });
    },
    backList() {
      this.$router.go(-1);
      // this.$router.push({
      //     path: "/coupon"
      // });
    },
  },
};
</script>
<style lang="less" scoped>
.w1000 {
  width: 1000px;
}
.w500 {
  width: 500px;
}
.w250 {
  width: 250px;
}
.w150 {
  width: 150px;
}
.lh75 {
  line-height: 75px;
}
.select-class {
  padding: 0 20px;
  border: 1px solid #bbb;
  span {
    background-color: #eee;
    padding: 5px 10px;
    margin: 10px;
    display: inline-block;
  }
}
</style>
